export default class State {
    constructor(config) {
        this.config = config;
        this.timer = null;
        this.internalState = {
            isReady: false,
            contactType: 0,
            canAdvance: false,
            bu: "",
            bl: "",
            country: "",
            region: "",
            tag:"",
            currentPage: "",
            currentContact: "",
            countries: [],
            requestTypes: [],
            jobTitles: [],
            departments: [],
            companyTypes: [],
            industries: [],
            taxonomy: {},
            blParents: {},
            applications: []
        };
        this.current = new Proxy(this.internalState, {
            set: (target, prop, value) => {
                if (this.config.isDevEnvironment) {
                    if (target.hasOwnProperty(prop)) {
                        console.log(`Setting existing property ${prop} to ${value}`);
                    } else {
                        console.log(`Setting non-existent property '${prop}', initial value: ${value}`);
                    }
                }
                target[prop] = value;
                //if (State.timer) clearTimeout(State.timer);
                //State.timer = setTimeout(() => {
                    this.notifySubscribers("changed", prop, value, this.internalState);
                //}, 100);

                return true;
            }
        });
        this.subscribers = {};
       
    }
    
    init() {

    }
    get(prop) {
        if (this.current.hasOwnProperty(prop)) return this.current[prop];
        else return undefined;
    }
    set(prop, value) {
        this.current[prop] = value;
    }
    subscribe(subscriber, handler) {
        if (!subscriber || !handler) return;
        console.log(`Subscribing ${subscriber} to state changes`);
        this.subscribers[subscriber] = handler;
    }
    unsubscribe(subscriber) {
        if (!subscriber) return;
        console.log(`Unsubscribing ${subscriber} from state changes`);
        if (this.subscribers.hasOwnProperty(subscriber)) {
            delete this.subscribers[subscriber];
        }
    }
    notifySubscribers(message, prop, value, internalState) {
        if (!message) return;
        for (let k in this.subscribers) {
            if (this.subscribers.hasOwnProperty(k) && this.subscribers[k]) {
                this.subscribers[k](message, prop, value, internalState);
            }
        }
    }
    atomicUpdate(message, props) {
        if (!message) return;
        if (!props) return;
        for (let k in props) {
            if (props.hasOwnProperty(k)) {
                this.internalState[k] = props[k];
            }
        }
        this.notifySubscribers(message, null, null, this.internalState);
    }
    clear () {
        this.atomicUpdate("clear", {
            contactType: 0,
            canAdvance: false,
            currentContact: ""
        });
    }
};